// eslint-disable-next-line no-shadow
enum ActionTypes {
  SET_ALERT_MODAL = "SET_ALERT_MODAL",
  CLEAR_ALERT_MODAL = "CLEAR_ALERT_MODAL",
}

export default ActionTypes;
